import { User } from "../models/sso/User";

class MenuService {
  getHomePageRoute(user: User): any {
    if (user) {
      const adminPortal = (user.isAdmin && window.location.href.indexOf("admin") >= 0) || (user.isAdmin && !user.accountId);
      return adminPortal ? { name: "admin/shipments" } : { name: "customer/dashboard" };
    } else {
      return "/";
    }
  }

  getHomePageUrl(user: User): any {
    if (user) {
      const adminPortal = (user.isAdmin && window.location.href.indexOf("admin") >= 0) || (user.isAdmin && !user.accountId);
      return adminPortal ? "/admin/shipments" : "/customer/dashboard";
    } else {
      return "/";
    }
  }
}

export default new MenuService();